import React, { createContext, useCallback, useEffect, useState } from 'react';
import useAuth from '../hooks/useAuth';
import { firestore } from './FirebaseContext';
import { isProduction } from '../config';
import { useParams, useLocation } from 'react-router';
import useControlRoutes from '../hooks/controlRoutes/useControlRoutes';

export const OriginActionContext = createContext({ originServer: '', originAplication: '' });

function OriginActionProvider({ children }) {
  const [originServer, setOriginServer] = useState('');
  const [originServerLocker, setOriginServeLocker] = useState('');
  const [originAplication, setOriginAplication] = useState('');

  const { pathname } = useLocation();
  const { workMode, localUrls, deployUrls } = useControlRoutes();

  // console.log(pathname, originServer, originAplication);

  useEffect(() => {
    // const origin = isProduction ? 'production' : 'sandbox';
    // setOriginServer(origin);
    if (workMode === 'development') {
      const servPlatf = localUrls?.find((it) => it?.section === 'service_platform');
      const servLocker = localUrls?.find((it) => it?.section === 'locker');

      setOriginServer(servPlatf?.extraDesc);
      setOriginServeLocker(servLocker?.extraDesc);
    }
    if (workMode === 'deploy') {
      const servPlatf = deployUrls?.find((it) => it?.section === 'service_platform');
      const servLocker = deployUrls?.find((it) => it?.section === 'locker');

      setOriginServer(servPlatf?.extraDesc);
      setOriginServeLocker(servLocker?.extraDesc);
    }
  }, [deployUrls, localUrls, workMode]);

  useEffect(() => {
    const arrUbication = pathname.split('/')[1];
    if (arrUbication === 'locker') {
      setOriginAplication('locker');
    }
    if (arrUbication !== 'locker') {
      setOriginAplication('dagPlataforma');
    }
  }, [pathname]);

  return (
    <OriginActionContext.Provider value={{ originServer, originServerLocker, originAplication, workMode }}>
      {children}
    </OriginActionContext.Provider>
  );
}

export default OriginActionProvider;
